import ActivityFlow from "@/views/apps/activity_flow/ActivityFlow";

import layouts from "@/layout";

export default {
  path: "/",
  alias: "/activity_flow",
  name: "activity_flow",
  component: ActivityFlow,
  meta: {
    auth: true,
    searchable: true,
    layout: layouts.navLeft,
    title: "Activity Flow",
    tags: ["flow", "activity", "activity_flow"]
  }
};
